import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: { main: "#3b82f6" },
        secondary: { main: "#9333ea" },
    },
    typography: {
        fontFamily: 'Poppins, Roboto, Arial',
        fontSize: 12, // Adjust this to your preferred size
    },
});

export default theme;